<div
  style="padding:0px;display: flex; flex-direction: row; justify-content: space-between; align-items: center; background: var(--side-menu);color: var(--side-menu-text-color); padding: 10px;">

  <p style="margin: 0;font-weight: bold;font-size: large">{{ title }}</p>
  <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 10px;">
    <!-- Düzenleme Butonu -->

     <ng-container *ngIf="dynamicButtons">
  
      <div style="display:flex;flex-wrap:wrap;gap:4px;">
        <dx-button *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn"
          [style]="dynamicButton?.style"
          id="dynamicButtonTop"
          [disabled]="dynamicButton?.disabled"
          [text]="dynamicButton?.text"
          [icon]="dynamicButton.icon"
          [type]="dynamicButton.type"
          [hint]="dynamicButton.hint"
          [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
          [stylingMode]="dynamicButton.stylingMode"
          (click)="handleDynamicButtonClick(dynamicButton)"
        ></dx-button>
      </div>

  </ng-container>

    <ng-container *ngIf="displayEditBtn">
      <dx-button class="edit-button"
        *ngIf="this.state !== 'New' && this.state !== 'View'"
        [(hint)]="editViewHint"
        [(text)]="duzenle"
        stylingMode="contained"
        type="default"
        (onClick)="toggleEdit()">
      </dx-button>
    </ng-container>
    <!-- Büyüt/Küçült Butonu -->
    <dx-button class="maximize-button"
      *ngIf="maximizable"
      [hint]="isFullScreen ? 'Küçült' : 'Büyüt'"
      [icon]="isFullScreen ? 'chevronup' : 'fullscreen'"
      stylingMode="outlined"
      (onClick)="toggleFullScreen()">
    </dx-button>
    <!-- Kapatma Butonu -->
    <dx-button class="close-button"
      *ngIf="isShowCancelButton"
      hint="Close"
      icon="close"
      stylingMode="outlined"
      (onClick)="closePopup()">
    </dx-button>
  </div>
</div>

